module.exports = __webpack_public_path__ + "img/L1_open.5615ce7f.svg";